import { useEffect, useState } from 'react';
import { onPendingChange } from '../data/writes';

/**
 * "8 visits waiting to upload", turning green at zero (PLAN 5.7).
 *
 * Backed by the IndexedDB queue, so it survives a force-quit and still reads 8
 * on reopen. It is the thing that stops a volunteer closing the app on a
 * shift's worth of unsent data.
 */
export function PendingBadge() {
  const [count, setCount] = useState(0);
  useEffect(() => onPendingChange(setCount), []);

  return (
    <span className={`pending${count === 0 ? ' pending--clear' : ''}`}>
      {count === 0 ? 'All saved' : `${count} uploading`}
    </span>
  );
}
